<p>actions-rent-info works!</p>
